import {
  createContext,
  useContext,
  type ReactElement,
  type ReactNode,
} from "react";
import type { PeopleSource } from "@playbookai/types";

const PeopleSourceContext = createContext<PeopleSource | null>(null);

/**
 * The canvas's `PeopleSource` for the widgets inside it: the host builds one
 * per canvas (its roster, its search scope, its grant mode) and every person
 * field in a widget reads it, so the widgets stay data-blind.
 */
export function PeopleSourceProvider({
  source,
  children,
}: {
  readonly source: PeopleSource;
  readonly children: ReactNode;
}): ReactElement {
  return (
    <PeopleSourceContext.Provider value={source}>
      {children}
    </PeopleSourceContext.Provider>
  );
}

/** The canvas's `PeopleSource`, or `null` outside a `PeopleSourceProvider`. */
export function usePeopleSource(): PeopleSource | null {
  return useContext(PeopleSourceContext);
}
